import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Form, Row, Col, Image, Button, Spinner } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
import Flex from 'components/common/Flex';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import UserContext from 'app/context/UserContext';
import axios from 'axios';
import { getImage, updateHeroImage } from 'app/api/PublicOptionsService';
import { toast } from 'react-toastify';

function HeroImageForm() {
  const [file, setFile] = useState(null);
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  
  useEffect(() => {
      getBannerImage();
    }, []);
  
    function getBannerImage() {
      axios(getImage(user.token))
      .then((response) => {
        setPreviewUrl(response.data.data[0].imageUrl)
        // Set state here if needed
      })
      .catch((error) => {
        console.error('Error fetching banner image:', error);
      });
    }
  
  function uploadFile(){
    setLoading(true)
    // Prepare FormData
    const formData = new FormData();
    formData.append('file', file);

    // Send the file via Axios request
    axios
      .request(updateHeroImage(user.token, formData))
      .then(() => {
        setLoading(false)
        toast.success('Image uploaded successfully!', {
          theme: 'colored',
        });
        getBannerImage();
        
      })
      .catch((error) => {
        setLoading(false)
        console.error('Upload error:', error);
        toast.error('Failed to upload image.', {
          theme: 'colored',
        });
      });
  }

  const onDropFiles = useCallback((acceptedFiles) => {
    if (Array.isArray(acceptedFiles) && acceptedFiles.length > 0) {
      const uploadedFile = acceptedFiles[0];
      setFile(uploadedFile);
      const fileUrl = URL.createObjectURL(uploadedFile);
        setPreviewUrl(fileUrl);
    }
  }, []);  

  const {
    getRootProps: getRootPropsFile,
    getInputProps: getInputPropsFile
  } = useDropzone({
    onDrop: onDropFiles,
    multiple: false,
    accept: 'image/*'
  });

  return (
    <div>
    <Row className="g-4 align-items-start">
      {/* Left: Uploader */}
      <Col md={6}>
        <Form.Label>Upload Image</Form.Label>
        <div
          {...getRootPropsFile({
            className: 'dropzone-area d-flex justify-content-center align-items-center',
          })}
          style={{
            height: '300px',
            borderRadius: '0.375rem',
            cursor: 'pointer',
          }}
        >
          <input {...getInputPropsFile()} />
          <Flex direction="column" alignItems="center">
            <img src={cloudUpload} alt="upload" width={40} className="mb-2" />
            <p className="fs-0 mb-0 text-700 text-center">Drop your file here</p>
          </Flex>
        </div>
      </Col>

      {/* Right: Image Preview */}
      <Col md={6}>
        <Form.Label>Preview</Form.Label>
        <div
          style={{
            height: '300px',
            borderRadius: '0.375rem',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {previewUrl ? (
            <Image
              src={previewUrl}
              alt="Preview"
              style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
              fluid
            />
          ) : (
            <p className="text-muted">No image selected</p>
          )}
        </div>
      </Col>
     
    </Row>
    {!loading ? (
          <Row className='mt-3'>
            <Col className="d-flex justify-content-end">
              <Button
                type="submit"
                disabled={!file}
                onClick={()=> uploadFile()}
                variant="success"
              >
                Save
              </Button>
            </Col>
          </Row>
        ) : (
            <Col className="d-flex justify-content-end">
          <Button variant="primary" disabled>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            <span>Loading...</span>
          </Button>
          </Col>
        )}
    </div>
  );
}

export default HeroImageForm;
